module.exports = __webpack_public_path__ + "static/media/047_g8_2Step 3 Create Show.3bb92d48.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/gigable/047_g8_2Step 3 Create Show.png
// module id = 454
// module chunks = 0